// 邀请成员: the one picker every invite uses (a 会议室's 邀请, public/meetinvite.js; the games' 邀请成员, public/invite.js),
// and the card an invited person gets. The picker lists the members online in this office (people first, then agents
// with the robot icon; each with their status (忙碌 / 请勿打扰 marked: they
// can still be invited, their card comes without a sound) and where they are; a search box when the list is long;
// tick one (max 1) or several, then send. What each caller adds: who to leave out, a note per row (how my last invite
// to them went), and what sending does.
// The card: 「X 邀请你…」 with 接受 / 稍后 (if the invite can wait) / 拒绝 and a countdown. In a game (an OtterBonk run,
// a game hut's full screen, a board game being played) 接受 becomes 「结束后再去」: whenFree() runs the walk once I'm
// back on the map. More than one: the oldest shows, 「还有 n 个邀请」; 稍后 folds a card into a chip under it.
import { icon, put } from '/icons.js';
import { inviteSound } from '/sounds.js';
import { t, tr, onLang } from '/i18n.js';

const SEARCH_FROM = 8; // rows before the search box shows
const CSS = `#mbpick{position:fixed;inset:0;z-index:45;display:none;align-items:center;justify-content:center;background:rgba(10,11,14,.55);font:14px/1.4 var(--ui-font,-apple-system,system-ui,sans-serif);color:#1b1410}
#mbpick.on{display:flex}
#mbpick .box{width:min(380px,calc(100vw - 24px));max-height:min(560px,calc(100vh - 40px));max-height:min(560px,calc(100dvh - 40px));display:flex;flex-direction:column;background:#fff8e7;border:3px solid #1b1410;border-radius:14px;box-shadow:0 4px 0 #1b1410;overflow:hidden}
#mbpick .hd{display:flex;align-items:center;gap:6px;padding:10px 12px;font-weight:700;border-bottom:2px solid #e3d3b0}
#mbpick .hd .sp{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
#mbpick .hd button{border:0;background:none;cursor:pointer;padding:2px}
#mbpick .q{margin:8px 10px 2px;font:inherit;padding:6px 10px;border:2px solid #1b1410;border-radius:10px;background:#fff}
#mbpick .ls{flex:1;overflow:auto;padding:4px 6px}
#mbpick .row{display:flex;align-items:center;gap:8px;padding:6px;border-radius:10px;cursor:pointer;user-select:none}
#mbpick .row:hover{background:#f4e6c6} #mbpick .row.dis{opacity:.55;cursor:default}
#mbpick .row input{width:18px;height:18px;accent-color:#1b1410;flex:none;margin:0}
#mbpick .row .nm{flex:1;min-width:0;display:flex;flex-direction:column}
#mbpick .row .nm b{font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
#mbpick .row .nm small{color:#776c5c;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
#mbpick .row .tag{font-size:11px;border-radius:6px;padding:0 5px;background:#e0e7ff;color:#3730a3;white-space:nowrap}
#mbpick .row .st{font-size:12px;font-weight:600;white-space:nowrap} #mbpick .row .st.busy{color:#b45309} #mbpick .row .st.away{color:#a16207} #mbpick .row .st.dnd{color:#dc2626}
#mbpick .row .iv{font-size:11px;border-radius:999px;padding:0 7px;white-space:nowrap;background:#e9e1cf;color:#5b5243}
#mbpick .row .iv.ok{background:#dcfce7;color:#15803d} #mbpick .row .iv.off{background:#f3f0ea;color:#999} #mbpick .row .iv.wait{background:#fef3c7;color:#92400e}
#mbpick .none{color:#888;padding:16px 8px;text-align:center}
#mbpick .ft{display:flex;align-items:center;gap:8px;padding:10px 12px;border-top:2px solid #e3d3b0}
#mbpick .ft .hint{flex:1;font-size:12px;color:#776c5c}
#mbpick .ft button{font:inherit;border:2px solid #1b1410;border-radius:999px;padding:5px 14px;background:#FDD03B;cursor:pointer;white-space:nowrap}
#mbpick .ft button:disabled{background:#eee;color:#888;cursor:default}
#mbcards{position:fixed;left:50%;top:calc(76px + var(--st,0px));transform:translateX(-50%);z-index:61;display:flex;flex-direction:column;align-items:center;gap:6px;width:min(340px,calc(100vw - 24px));pointer-events:none;font:14px/1.4 var(--ui-font,-apple-system,system-ui,sans-serif);color:#1b1410}
#mbcards>*{pointer-events:auto}
#mbcard{display:none;box-sizing:border-box;width:100%;background:#fff8e7;border:3px solid #1b1410;border-radius:14px;box-shadow:0 3px 0 #1b1410;padding:10px 12px;animation:mbPop .25s ease-out}
#mbcard.quiet{border-color:#ef4444;box-shadow:0 3px 0 #ef4444}
#mbcard .t{display:flex;gap:6px;align-items:flex-start;font-weight:600;word-break:break-word}
#mbcard .sub{font-size:12px;color:#776c5c;margin:4px 0 8px;display:flex;gap:8px;align-items:center;flex-wrap:wrap}
#mbcard .sub .qt{color:#dc2626;font-weight:600}
#mbcard .cdown{height:3px;background:#e9e1cf;border-radius:2px;overflow:hidden;margin-bottom:8px} #mbcard .cdown i{display:block;height:100%;background:#FDD03B}
#mbcard .bt{display:flex;gap:6px;flex-wrap:wrap}
#mbcard button{font:inherit;font-size:13px;border:2px solid #1b1410;border-radius:999px;padding:4px 12px;background:#fff;cursor:pointer;white-space:nowrap}
#mbcard button.go{background:#FDD03B}
#mbchips{display:flex;flex-wrap:wrap;gap:6px;justify-content:center}
#mbchips button{font:inherit;font-size:12px;border:2px solid #1b1410;border-radius:999px;padding:2px 10px;background:#fff8e7;cursor:pointer;box-shadow:0 2px 0 #1b1410}
@keyframes mbPop{from{transform:translateY(-6px);opacity:0}to{transform:none;opacity:1}}`;

const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };

/**
 * @param o {me, peers, zoneAt, statusOf, STATES, agentName?, gomoku?: {current()}, mover?: deck/move.js, MAP?, toast?}
 */
export function initMembers(o) {
  const st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  // (someone on another boat, from a caller's extra(): where they are is the caller's to say)
  const where = (p) => { if (p.far) return p.at ? t(`members.where.${p.at}`) : p.where ?? ''; const z = o.zoneAt(p.x, p.y); return z ? z.name : t(p.boat ? 'members.where.sea' : 'members.where.deck'); };

  // ---- the picker
  const pickEl = el('div'); pickEl.id = 'mbpick';
  const box = el('div', 'box'), hd = el('div', 'hd'), hdIcon = el('span'), title = el('span', 'sp'), x = el('button'); x.append(icon('close')); tr(x, null, null, { title: 'members.close' });
  hd.append(hdIcon, title, x);
  const q = el('input', 'q'); tr(q, null, null, { placeholder: 'members.search' }); q.autocomplete = 'off';
  const ls = el('div', 'ls'), ft = el('div', 'ft'), hint = el('span', 'hint'), go = el('button');
  const topEl = el('div'); // the caller's own block above the list (opts.top: 参会链接, public/meetlink.js)
  ft.append(hint, go); box.append(hd, topEl, q, ls, ft); pickEl.append(box);
  pickEl.onclick = (e) => { if (e.target === pickEl) close(); };
  x.onclick = () => close();
  // nothing typed or pressed here walks the otter
  for (const t of ['keydown', 'keyup']) pickEl.addEventListener(t, (e) => { if (e.key === 'Escape') close(); e.stopPropagation(); });
  q.oninput = () => paint();
  // Esc closes it wherever the focus is (after 发送邀请 the focus may have left the box)
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && cur && !e.target.closest?.('.dd-list')) { e.stopPropagation(); close(); } }, true);
  let cur = null, chosen = new Set();
  go.onclick = () => {
    const extra = new Set((cur?.extra?.() ?? []).map((p) => p.id));
    const ids = [...chosen].filter((id) => o.peers().has(id) || extra.has(id));
    if (!ids.length || !cur) return;
    cur.onSend(ids); chosen = new Set(); if (cur.closeOnSend) close(); else paint();
  };

  /** Online here, one per person, not me, not left out by the caller: people first, then agents; by name. Then the
   *  caller's extra() (people elsewhere, shaped like peers with far: true and where), the same way. */
  function members() {
    const seen = new Set(), me = o.me(), out = [];
    for (const p of o.peers().values()) {
      const k = p.sub || p.id;
      if (seen.has(k) || (me && ((me.sub && k === me.sub) || p.id === me.id)) || cur?.exclude?.(p)) continue;
      seen.add(k); out.push(p);
    }
    const order = (a, b) => (a.kind === 'agent') - (b.kind === 'agent') || a.name.localeCompare(b.name, 'zh');
    const more = (cur?.extra?.() ?? []).filter((p) => !cur?.exclude?.(p)).sort((a, b) => (a.where ?? '').localeCompare(b.where ?? '', 'zh') || order(a, b));
    return [...out.sort(order), ...more];
  }
  function paint() {
    if (!cur || !pickEl.classList.contains('on')) return;
    if (cur.alive && !cur.alive()) { close(); return; }
    title.textContent = typeof cur.title === 'function' ? cur.title() : cur.title;
    const all = members(), needle = q.value.trim().toLowerCase();
    q.style.display = all.length > SEARCH_FROM || needle ? '' : 'none';
    const list = needle ? all.filter((p) => p.name.toLowerCase().includes(needle)) : all;
    const ids = new Set(all.map((p) => p.id));
    for (const id of chosen) if (!ids.has(id)) chosen.delete(id);
    // rebuilt only when something shown changed (a row replaced under the pointer would lose the click)
    const rows = list.map((p) => ({ p, s: p.kind === 'agent' ? null : o.statusOf(p), n: cur.state?.(p) ?? null }));
    const sig = JSON.stringify([needle, cur.max, rows.map(({ p, s, n }) => [p.id, p.name, where(p), s, n])]);
    if (sig !== ls.dataset.sig) {
      ls.dataset.sig = sig;
      if (!rows.length) ls.replaceChildren(el('div', 'none', needle ? t('members.noMatch') : cur.emptyText ?? t('members.empty')));
      else ls.replaceChildren(...rows.map(({ p, s, n }) => {
        const r = el('label', 'row'), cb = el('input'); cb.type = cur.max === 1 ? 'radio' : 'checkbox'; cb.name = 'mbpick'; cb.checked = chosen.has(p.id);
        cb.disabled = !!n?.lock; if (n?.lock) r.classList.add('dis');
        cb.onchange = () => { if (cur.max === 1) chosen = new Set(); else if (cb.checked && cur.max && chosen.size >= cur.max) { cb.checked = false; o.toast?.(t('members.maxReached', { max: cur.max })); return; } if (cb.checked) chosen.add(p.id); else chosen.delete(p.id); foot(); };
        const nm = el('span', 'nm');
        nm.append(el('b', '', o.agentName ? o.agentName(p) : p.name), put(el('small'), 'pin', where(p)));
        r.append(cb, icon(p.kind === 'agent' ? 'robot' : o.STATES[s?.s ?? 'available'].icon), nm);
        if (s) { const sp = el('span', 'st ' + s.s, s.s === 'dnd' ? t('members.dndQuiet') : o.STATES[s.s].name); sp.title = s.note ?? ''; r.append(sp); }
        if (n?.text) r.append(el('span', 'iv ' + (n.cls ?? ''), n.text));
        return r;
      }));
    }
    foot();
  }
  function foot() {
    if (!cur) return;
    const k = chosen.size;
    go.disabled = !k; put(go, cur.icon ?? 'people', k ? t('members.sendCount', { label: cur.sendLabel ?? t('members.send'), n: k }) : cur.sendLabel ?? t('members.send'));
    hint.textContent = k ? '' : cur.hint ?? (cur.max === 1 ? t('members.hint.one') : cur.max ? t('members.hint.max', { max: cur.max }) : t('members.hint.many'));
  }
  /** Open the picker. opts: {title (or a function), icon, sendLabel, hint, emptyText, max (1: one only), extra() (more
   *  people, elsewhere: [{id, name, kind, status?, far: true, where}]), exclude(p), top() (an element shown above the list),
   *  state(p) -> {text, cls: ok|off|wait, lock} | null, onSend(ids), alive() (false closes it), closeOnSend} */
  function pick(opts) {
    cur = opts; chosen = new Set(); q.value = ''; ls.dataset.sig = '';
    topEl.replaceChildren(...(opts.top ? [opts.top()] : []));
    hdIcon.replaceChildren(icon(opts.icon ?? 'people'));
    pickEl.classList.add('on'); paint();
  }
  function close() { pickEl.classList.remove('on'); cur = null; }

  // ---- the cards (invites to me)
  const stack = el('div'); stack.id = 'mbcards';
  const card = el('div'); card.id = 'mbcard';
  const chips = el('div'); chips.id = 'mbchips';
  stack.append(card, chips);
  document.body.append(pickEl, stack);
  const newFns = [];
  const cards = new Map(); // id -> {id, icon, text, quiet, expires, shownAt, folded, accept(defer), decline(), later?()}
  let shown = null;

  /** In a game: an OtterBonk run, a game hut's full screen, or seated at a board game being played. */
  function busy() {
    if (document.querySelector('body > .ob')) return true;
    // the huts' full screens are position:fixed (offsetParent is always null for those): ask whether they're laid out
    if ([...document.querySelectorAll('.gfull')].some((e) => getComputedStyle(e).display !== 'none' && e.getClientRects().length > 0)) return true;
    const t = o.gomoku?.current?.(), me = o.me(), k = me?.gid ?? me?.id;
    return !!(t && t.phase === 'playing' && t.seats?.some((s) => s && s.id === k));
  }
  /** A call ringing me first (it lasts seconds), then cards with a prio (日历: a meeting starting), then the rest. */
  const rank = (c) => (c.anytime && c.prio == null ? 2 : c.prio ?? 0);
  function show() {
    const now = Date.now();
    for (const [id, c] of cards) if (c.expires <= now) cards.delete(id);
    const open = [...cards.values()].filter((c) => !c.folded).sort((a, b) => rank(b) - rank(a)), c = open[0] ?? null; // (a call ringing, then a meeting starting, before invites)
    if (!c) { card.style.display = 'none'; shown = null; }
    else {
      const inGame = busy(), key = [c.id, inGame, c.quiet, open.length].join();
      if (shown !== key) {
        shown = key;
        card.classList.toggle('quiet', !!c.quiet);
        const head = el('div', 't'); head.append(icon(c.icon ?? 'people'), el('span', '', c.text));
        const sub = el('div', 'sub'); sub.append(el('span', 'left'));
        if (c.quiet) sub.append(put(el('span', 'qt'), 'dnd', t('members.card.quiet')));
        if (open.length > 1) sub.append(el('span', '', t('members.card.more', { n: open.length - 1 })));
        const bar = el('div', 'cdown'); bar.append(el('i'));
        // in a game: 「结束后再去」 if the invite can wait (c.defer), else 接受 waits until the game is over
        // c.anytime (a call: nothing to walk to): 接受 / its own label works in a game too
        const yes = el('button', 'go'), wait = inGame && !c.defer && !c.anytime;
        put(yes, c.yesIcon ?? 'check', c.anytime ? c.yes ?? t('members.card.accept') : inGame && c.defer ? t('members.card.afterGame') : c.yes ?? t('members.card.accept')); yes.disabled = wait;
        yes.title = c.anytime ? '' : wait ? t('members.card.tip.wait') : inGame ? t('members.card.tip.afterGame') : c.yesTitle ?? t('members.card.tip.walk');
        yes.onclick = () => { cards.delete(c.id); c.accept(inGame && !c.anytime); show(); };
        const bt = el('div', 'bt'); bt.append(yes);
        if (c.later) { const b = put(el('button'), 'timer', t('members.card.later')); b.onclick = () => { c.folded = true; if (c.laterMs) { c.shownAt = Date.now(); c.expires = c.shownAt + c.laterMs; } c.later(); show(); }; bt.append(b); }
        const no = put(el('button'), c.noIcon ?? 'close', c.no ?? t('members.card.decline')); no.onclick = () => { cards.delete(c.id); c.decline(); show(); };
        bt.append(no);
        card.replaceChildren(head, sub, bar, bt);
        card.style.display = 'block';
      }
      const ms = Math.max(0, c.expires - now), all = Math.max(1, c.expires - c.shownAt);
      card.querySelector('.left').textContent = c.left ? c.left(ms) : ms > 120_000 ? t('members.card.leftMin', { n: Math.ceil(ms / 60_000) }) : t('members.card.leftSec', { n: Math.ceil(ms / 1000) });
      card.querySelector('.cdown i').style.width = `${(100 * ms) / all}%`;
    }
    const folded = [...cards.values()].filter((f) => f.folded);
    const sig = folded.map((f) => f.id).join();
    if (chips.dataset.sig !== sig) {
      chips.dataset.sig = sig;
      chips.replaceChildren(...folded.map((f) => { const b = put(el('button'), f.icon ?? 'people', f.chip ?? f.text); b.title = t('members.card.chipTip'); b.onclick = () => { f.folded = false; shown = null; show(); }; return b; }));
    }
  }
  /** Show (or update) an invite card. c: {id, icon, text, chip?, quiet, expires, folded?, accept(defer), decline(), later?(),
   *  laterMs? (稍后 keeps it this much longer), defer? (accepting in a game can mean 「结束后再去」; else 接受 waits for the
   *  game to end), anytime? (accepting works in a game as anywhere: a call), yes? / yesIcon? / no? / noIcon? (the
   *  buttons' own words: 接听 / 拒绝), silent? (no chime: the caller plays its own ring tone), yesTitle?,
   *  left(ms) (the line under the title: 「N 秒内回复」 by default), prio (higher shows first) (日历's reminders, public/calendar.js)} */
  function addCard(c) {
    const was = cards.get(c.id);
    cards.set(c.id, { ...c, shownAt: was?.shownAt ?? Date.now(), folded: c.folded ?? was?.folded ?? false });
    if (!was && !c.quiet && !c.folded && !c.silent) inviteSound(c.icon === 'door'); // a 会议室 rings, the rest chime (public/sounds.js)
    if (!was && !c.folded) for (const fn of newFns) { try { fn(c); } catch (e) { console.error(e); } }
    shown = null; show();
  }
  function dropCard(id) { if (cards.delete(id)) { shown = null; show(); } }

  // 「结束后再去」: run once I'm out of the game and on the map (within 30 minutes, or `until`); one per key
  const waiting = [];
  function whenFree(fn, key = null, until = Date.now() + 30 * 60_000) { if (key) unwait(key); waiting.push({ fn, key, until }); }
  function unwait(key) { for (let i = waiting.length - 1; i >= 0; i--) if (waiting[i].key === key) waiting.splice(i, 1); }
  /** Walk my otter into zone `rid`: the floor tile nearest its middle (as the office's walk.ts does for agents). */
  async function walkToZone(rid, name) {
    const z = o.MAP.zones.find((r) => r.id === rid), me = o.me();
    if (!z || !me || o.zoneAt(me.x, me.y)?.id === rid) return;
    const cx = z.x + z.w / 2, cy = z.y + z.h / 2;
    let best = null, bd = Infinity;
    for (let y = Math.floor(z.y); y < z.y + z.h; y++) for (let x = Math.floor(z.x); x < z.x + z.w; x++) {
      const d = Math.hypot(x + 0.5 - cx, y + 0.5 - cy);
      if (d < bd && o.mover.footOk(x, y) && o.zoneAt(x, y - 0.3)?.id === rid) { bd = d; best = [x, y]; }
    }
    o.mover.keys?.clear?.();
    if (!best) { o.toast(t('members.walk.noZoneRoute', { name })); return; }
    const started = await o.mover.travelTo(best[0], best[1], true, [best[0], best[1] - 0.3]);
    if (started === null) return;
    if (!started) { o.toast(t('members.walk.noZoneRoute', { name })); return; }
    o.toast(t('members.walk.toZone', { name }), null, 'door');
  }

  /** Walk my otter up to `p` (a peer: where they stand now), as the card's 走过去 (greet.js) does. */
  async function walkTo(p, name) {
    const me = o.me(); if (!p || !me) return;
    o.mover.keys?.clear?.();
    const started = await o.mover.travelTo(Math.floor(p.x + 0.5), Math.floor(p.y + 0.8), false, null);
    if (started === null) return;
    if (!started) { o.toast(t('members.walk.noRoute', { name })); return; }
    o.toast(t('members.walk.toPerson', { name }), null, 'flag');
  }

  // the language changed: the open picker's rows and the card, drawn again
  onLang(() => { ls.dataset.sig = ''; chips.dataset.sig = ''; shown = null; show(); paint(); });

  setInterval(() => {
    show(); paint();
    for (let i = waiting.length - 1; i >= 0; i--) {
      const w = waiting[i];
      if (Date.now() > w.until) waiting.splice(i, 1);
      else if (!busy() && o.me()) { waiting.splice(i, 1); w.fn(); }
    }
  }, 1000);

  /** The invite cards to me now, oldest first (for the 小窗, public/pip.js): {id, icon, text, quiet, expires, folded,
   *  later: can wait, defer, inGame: as the card's 接受 / 结束后再去}. answer(id, 'accept' | 'later') does what the card's buttons do. */
  function list() { const now = Date.now(), inGame = busy(); return [...cards.values()].filter((c) => c.expires > now).map((c) => ({ id: c.id, icon: c.icon, text: c.text, quiet: !!c.quiet, expires: c.expires, folded: !!c.folded, later: !!c.later, defer: !!c.defer, inGame, yes: c.yes, yesIcon: c.yesIcon, yesTitle: c.yesTitle })); }
  function answer(id, a) {
    const c = cards.get(id); if (!c) return;
    if (a === 'accept') { const inGame = busy() && !c.anytime; if (inGame && !c.defer) return; cards.delete(id); c.accept(inGame); }
    else if (a === 'later' && c.later) { c.folded = true; if (c.laterMs) { c.shownAt = Date.now(); c.expires = c.shownAt + c.laterMs; } c.later(); }
    shown = null; show();
  }
  /** fn(card) for each new invite card (the 小窗's system notification when the page is in the background). */
  function onNew(fn) { newFns.push(fn); }
  return { pick, close, refresh: paint, isOpen: () => !!cur, addCard, dropCard, busy, whenFree, unwait, walkToZone, walkTo, list, answer, onNew };
}
